import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { BaseForm } from "@app/data/shared/models/base-form.interface";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { SectorDto } from "@dashboard/modules/management/sector/model/sector.dto";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { UtilService } from "@app/modules/shared/services/util.service";

@Component({
  selector: "kl-new-sector",
  templateUrl: "./sector-form.component.html",
  styleUrls: ["./sector-form.component.scss"],
})
export class SectorFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  @Input() mode: string;
  @Input() isReadOnly: boolean;
  @Input() entity: SectorDto = new SectorDto();
  title = "";
  alertMessage: string;
  alertShow: boolean;
  alertType: string;
  generateCodeSpin = false;
  errorShow = false;
  isOpen = true;

  constructor(
    private apiService: ApiService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private utilService: UtilService,
    private alertService: KlSweetAlertService,
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {
    if (this.mode === "add") {
      this.title =
        this.translateService.instant("new") +
        " " +
        this.translateService.instant("sector");
      this.entity.status = "ACTIVE";
      this.generateCode();
    } else {
      this.title = this.translateService.instant("sector") + " - ";
    }
  }

  ngAfterViewInit() {
    this.elementFocus.nativeElement.focus();
  }

  generateCode() {
    this.generateCodeSpin = true;
    this.apiService.generateCode("sector").subscribe(
      (resCode) => {
        this.entity.code = resCode.value;
        this.generateCodeSpin = false;
        this.formChange(true);
      },
      (errCode) => this.handleError(errCode)
    );
  }

  clearForm() {
    this.elementFocus.nativeElement.focus();
    this.entity.status = "ACTIVE";
    this.entity.description = "";
    this.generateCode();
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  commitSave(action: any) {
    this.klLoadingService.show("saving");
    switch (action) {
      case "SAVE":
        switch (this.mode) {
          case "add":
            this.apiService.addData("sector", this.entity).subscribe(
              () => this.handleResponse(),
              (error) => this.handleError(error)
            );
            break;
          case "edit":
            this.apiService.updateData("sector", this.entity).subscribe(
              () => this.handleResponse(),
              (error) => this.handleError(error)
            );
            break;
        }
        break;
      case "SAVE_NEW":
        this.apiService.addData("sector", this.entity).subscribe(
          (response) => this.handleNew(response),
          (error) => this.handleError(error)
        );
        break;
    }
  }

  handleResponse() {
    this.klLoadingService.hide();
    this.errorShow = false;
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew(response) {
    this.klLoadingService.hide();
    this.errorShow = false;
    this.toastService.toastSuccess();
    this.clearForm();
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.errorShow = false;
    this.alertShow = false;
    this.alertType = "error";
  }

  unlockEntity() {
    this.apiService.unlockData("sector", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
  }
}
